import { format } from 'date-fns';
import { fr, enUS } from 'date-fns/locale';
import i18n from 'i18next';

export const formatDate = (dateString) => {
    if (!dateString) {
        return '';
    }
    const date = new Date(dateString);

    let formatPattern = "yyyy-MM-dd"; // Anglais (défaut)
    let locale = enUS;

    if (i18n.language.startsWith('fr')) { // Français
        formatPattern = "dd/MM/yyyy";
        locale = fr;
    }

    return format(date, formatPattern, { locale });
};

export const formatDateTime = (dateString) => {
    if (!dateString) {
        return '';
    }
    const date = new Date(dateString);

    let formatPattern = "yyyy-MM-dd HH:mm"; // Anglais (défaut)
    let locale = enUS;

    if (i18n.language.startsWith('fr')) { // Français
        formatPattern = "dd/MM/yyyy HH:mm";
        locale = fr;
    }

    return format(date, formatPattern, { locale });
};

export const extractBestTranslation = (translations, lang) => {
    if (!translations) {
        return '';
    }
    if (translations[lang]) {
        return translations[lang];
    }
    if (translations.en) {
        return translations.en;
    }
    return Object.values(translations)[0];
};
